import { render, staticRenderFns } from "./TabPurchaseOrder.vue?vue&type=template&id=226ffa86&lang=pug&"
import script from "./TabPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./TabPurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./TabPurchaseOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports